<div class="main-container">
  <h1 mat-dialog-title>Are you sure you want to cancel this reminder?</h1>
  <div class="button-container" mat-dialog-actions>
    <button mat-button color="warn" [mat-dialog-close]="yesButtonClicked()">
      Yes
    </button>
    <button type="button" mat-button [mat-dialog-close]="noButtonClicked()">
      No
    </button>
  </div>
</div>
